import { faqs } from "@/mocks/faqs";
import FaqList from "@/components/feature/FaqList";
import SectionHeading from "@/components/feature/SectionHeading";

export default function FaqSection() {
  return (
    <section className="mx-auto max-w-[1200px] px-4 py-14 md:px-8 md:py-16" aria-labelledby="faq-heading">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[340px_1fr] lg:gap-12">
        <div id="faq-heading">
          <SectionHeading
            eyebrow="常见问题"
            title="关于求证，你想知道的多半在这里"
            desc="如果还有别的疑问，可以在联系我们页面留言，我们会挑常见的问题补充到这里。"
          />
          <div className="hidden rounded-lg border border-background-200 bg-secondary-50 p-5 lg:block">
            <p className="font-heading text-sm font-bold text-secondary-900">还有细节想问？</p>
            <p className="mt-2 text-[13px] leading-relaxed text-secondary-800">
              关于材料提交方式、脱敏规则、档案更新机制，都可以直接提问。
            </p>
          </div>
        </div>
        <FaqList items={faqs} />
      </div>
    </section>
  );
}